export enum ListPageAnchorEnum {
  overview = 'overview',
  features = 'features',
  pricing = 'pricing',
  contact = 'contact',
}
